import script from "./ConversationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationList.vue?vue&type=script&setup=true&lang=js"

import "./ConversationList.vue?vue&type=style&index=0&id=5ce8aa67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce8aa67"]])

export default __exports__